export default __webpack_public_path__ + "static/media/video1.bf170839.jpg";